import React, { useRef, useEffect } from 'react';

const COLORS = ['#b5dc6e', '#a5dbf0', '#f3a1ae', '#d5c4ac'];
const CENTER_RESTRICT_RADIUS = 180; // Radio del área central protegida

const createParticle = (width, height) => {
  const corner = Math.floor(Math.random() * 4);
  let x, y;
  switch (corner) {
    case 0:
      x = Math.random() * 50;
      y = Math.random() * 50;
      break;
    case 1:
      x = width - Math.random() * 50;
      y = Math.random() * 50;
      break;
    case 2:
      x = Math.random() * 50;
      y = height - Math.random() * 50;
      break;
    case 3:
      x = width - Math.random() * 50;
      y = height - Math.random() * 50;
      break;
  }
  const angle = Math.random() * 2 * Math.PI;
  const speed = 0.3 + Math.random() * 0.5;
  return {
    x,
    y,
    r: 3 + Math.random() * 2,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
    vx: Math.cos(angle) * speed,
    vy: Math.sin(angle) * speed,
    phase: Math.random() * Math.PI * 2,
    opacity: 0,
    update(t, width, height, elapsed) {
      // Fade-in control
      this.opacity = Math.min(1, elapsed / 2000);

      this.x += this.vx;
      this.y += this.vy;
      // Rebote en bordes
      if (this.x < 0 || this.x > width) this.vx *= -1;
      if (this.y < 0 || this.y > height) this.vy *= -1;

      // Evitar el centro
      const cx = width / 2;
      const cy = height / 2;
      const dx = this.x - cx;
      const dy = this.y - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < CENTER_RESTRICT_RADIUS) {
        const angle = Math.atan2(dy, dx);
        const repelForce = (CENTER_RESTRICT_RADIUS - dist) * 0.05;
        this.vx += Math.cos(angle) * repelForce;
        this.vy += Math.sin(angle) * repelForce;
      }
    },
    draw(ctx, t, elapsed) {
      if (elapsed < 2000) return; // No dibujar nada antes de 2 segundos

      const radius = this.r + Math.sin(this.phase + t * 0.002) * 0.5;
      ctx.beginPath();
      ctx.arc(this.x, this.y, radius, 0, Math.PI * 2);
      ctx.fillStyle = this.color;
      ctx.globalAlpha = this.opacity;
      ctx.fill();
      ctx.globalAlpha = 1;
    }
  };
};

const ParticlesFromCorners = () => {
  const canvasRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    let particles = Array.from({ length: 50 }, () => createParticle(width, height));
    const startTime = performance.now();

    const resize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener('resize', resize);

    const animate = (t) => {
      const elapsed = t - startTime;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
      particles.forEach(p => p.update(t, width, height, elapsed));
      particles.forEach(p => p.draw(ctx, t, elapsed));
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
    return () => window.removeEventListener('resize', resize);
  }, []);

  return <canvas ref={canvasRef} style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }} />;
};

export default ParticlesFromCorners;
